import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import './ReSign.scss';
import ReSignContact from './ReSignContact';

const getExpiredLinkMessage = (error) => {
  if (error === 'Offer Already Accepted') {
    return (
      <div>
        <div>It looks like you&apos;ve already accepted this deal.</div>
        If you need to get in contact us with us, you can do so via one of the options below:
      </div>
    );
  } else if (error === 'Expired Link') {
    return (
      <div>
        <div>It looks like this offer has already expired.</div>
        Not to fret, our care team will be able to sort you out, you can get in contact with them
        via one of the options below:
      </div>
    );
  } else if (error === 'Maximum Open Count Exceeded') {
    return (
      <div>
        <div>It looks like you&apos;ve used this link too many times.</div>
        If you need to get in contact us with us, you can do so via one of the options below:
      </div>
    );
  }
  return null;
};


const ReSignCustomerInfo = (props) => {
  const {
    givenName, surname, currentPlan, email, contractEndDate, linkValid, errorMessage, resignPromoText
  } = props.info;


  return (
    <div>
      {linkValid ?
        <div className="customer-info">
          <h2>Simply renew your 12-month plan</h2>
          <h4>Hi {startCase(givenName)}, thanks for being a Skinny Broadband customer!</h4>
          <p>
            {`You know we love keeping our prices low and customers happy, so what better way to do
            it than give you ${resignPromoText ?
              `${resignPromoText.toLowerCase()} of ` : ''
              }Broadband on us! All you need to do is confirm your details
            below, and hit "submit order"! Super simple.`}
          </p>
          <p className="high-light">
            <ul>
              <li>
                <div className="customer-attribute-name">Name</div>
                <div>{startCase(givenName)} {startCase(surname)}</div>
              </li>
              <li>
                <div className="customer-attribute-name">Email</div>
                <div>{email}</div>
              </li>
              <li>
                <div className="customer-attribute-name">Plan</div>
                <div>{currentPlan}</div>
              </li>
              <li>
                <div className="customer-attribute-name">Current contract end date</div>
                <div>{contractEndDate}</div>
              </li>
            </ul>
          </p>
          <p>
            Are these details correct? Sweet as – just hit &quot;submit order&quot; and we&apos;ll
            take care of the rest.
          </p>
        </div> : <div>
          <h2>Whoops, something went wrong...</h2>
          {getExpiredLinkMessage(errorMessage)}
          <ReSignContact />
        </div>
      }
    </div>
  );
};

ReSignCustomerInfo.propTypes = {
  info: PropTypes.object
};

export default ReSignCustomerInfo;



/** WEBPACK FOOTER **
 ** ./src/components/ReSign/ReSignCustomerInfo.js
 **/